import { AssetId } from '~modules/media-library/model/Asset';
import { ApprovalForm } from '~modules/media-library/view/ApprovalForm/ApprovalForm';

type ApprovalFormControllerProps = {
  assetId: AssetId;
  onClose?: () => void;
};

export function ApprovalFormController({ assetId, onClose }: ApprovalFormControllerProps) {
  return <ApprovalForm assetId={assetId} onClose={onClose} />;
}
